import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/card';
import { DashboardFilterBar } from '@/features/dashboard-filters';
import { PageHeader } from '@/shared/ui';

import { useServiceUsers } from '../model';
import { ServiceStats, ActivityChart, TopListsGrid, ServiceSummary } from './components';

export function ServiceUsersPage() {
  const { t } = useTranslation();
  const {
    data,
    formattedStats,
    locationsData,
    organizationGroups,
    isFetching,
    locationsLoading,
    organizationsLoading,
    error,
    urlState,
    selectedLocations,
    selectedOrganizations,
    updateOption,
    handleDateRangeChange,
    setSelectedLocations,
    setSelectedOrganizations
  } = useServiceUsers();

  if (error) {
    return (
      <div>
        <Card className="p-4 md:p-6">
          <p className="text-destructive">Error loading service users data</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-4 md:space-y-6">
      <PageHeader title={t('welcome.serviceusers.label', 'Service Users')} />

      <DashboardFilterBar
        variant="service-users"
        options={urlState}
        onOptionChange={updateOption}
        locationGroups={locationsData?.locationGroups}
        selectedLocations={selectedLocations}
        onLocationsChange={setSelectedLocations}
        locationsLoading={locationsLoading}
        organizationGroups={organizationGroups}
        selectedOrganizations={selectedOrganizations}
        onOrganizationsChange={setSelectedOrganizations}
        organizationsLoading={organizationsLoading}
        onDateRangeChange={handleDateRangeChange}
      />

      <ServiceStats stats={formattedStats} isLoading={isFetching} />
      <ActivityChart data={data?.serviceUsers} isLoading={isFetching} />
      <TopListsGrid topProducts={data?.topProducts} topServiceUsers={data?.topServiceUsers} isLoading={isFetching} />
      <ServiceSummary stats={formattedStats} />
    </div>
  );
}
